import { useEffect } from 'react';
import { api } from '../utils/api';
import { useEditorStore } from '../store/editorStore';
import { useWorkspace } from '../contexts/WorkspaceContext';

export function useTelemetry(code: string | undefined) {
  const { activeLens, setTelemetryData, racks, rows, whatIfActive } = useEditorStore();
  const { activeWorkspaceId } = useWorkspace();

  useEffect(() => {
    if (activeLens === 'none' || !code || whatIfActive) return;
    const endpoint = activeLens === 'spof' ? 'spof' : 'telemetry-mock';
    api.get(`/api/datacenters/${code}/${endpoint}`, {
      params: { workspace: activeWorkspaceId }
    }).then(r => {
      let mapped: Record<string, any> = {};
      if (Array.isArray(r.data)) {
        r.data.forEach((item: any) => {
          const rackId = `rack-${item.row_index}-${item.rack_index}`;
          mapped[rackId] = { 
            temperature: item.temp_c ?? item.temperature ?? 20, 
            powerLoad: item.power_w ? item.power_w / 1000 : (item.powerLoad ?? 0), 
            powerCapacity: item.powerCapacity ?? 10, 
            usedU: item.usedU ?? item.used_u ?? 0,
            totalU: item.totalU ?? item.total_u ?? 42,
            hasSpof: item.hasSpof ?? false,
            spofReason: item.spofReason
          };
        });
      } else if (r.data && typeof r.data === 'object') {
        Object.entries(r.data).forEach(([key, val]: [string, any]) => {
          mapped[`rack-${key}`] = { 
            temperature: val.temperature ?? 20, 
            powerLoad: val.powerLoad ?? (val.power_w ? val.power_w / 1000 : 0), 
            powerCapacity: val.powerCapacity ?? 5, 
            usedU: val.usedU ?? val.used_u ?? 0,
            totalU: val.totalU ?? val.total_u ?? 42,
            hasSpof: val.hasSpof ?? false,
            spofReason: val.spofReason
          };
        });
      }
      Object.values(racks).forEach((rack: any) => {
        let row = 1;
        if (rack.rowId && rows && rows[rack.rowId]?.labelIndex) {
          row = rows[rack.rowId].labelIndex;
        } else if (rack.row_index != null) {
          row = rack.row_index;
        } else if (rack.rowIndex != null && rack.rowIndex < 10000) {
          row = rack.rowIndex;
        } else if (rack.row != null) {
          row = rack.row;
        }
        const col = rack.rackPosInRow ?? rack.rackIndex ?? rack.col ?? rack.rack_index ?? 1;
        const coordKey = `rack-${row}-${col}`;
        const dataVal = mapped[coordKey] || mapped[rack.id];
        const isPillar = Boolean(rack.isBlocked || rack.rackType === 'pillar');
        const isFac = Boolean(rack.isFacility || ['crac', 'inrow_cooler', 'ups', 'pdu_frame'].includes(rack.rackType));
        const defTotalU = (isFac || isPillar) ? 0 : (rack.uCount ?? 42);
        
        mapped[rack.id] = dataVal ? {
          ...dataVal,
          totalU: (isFac || isPillar) ? 0 : (dataVal.totalU ?? defTotalU),
          usedU: (isFac || isPillar) ? 0 : (dataVal.usedU ?? 0),
        } : {
          temperature: 20.0,
          powerLoad: 0.0,
          powerCapacity: rack.max_power_w ? rack.max_power_w / 1000.0 : 5.0,
          usedU: 0,
          totalU: defTotalU,
          hasSpof: false
        };
      });
      setTelemetryData(mapped);
    }).catch(console.error);
  }, [activeLens, code, racks, rows, setTelemetryData, activeWorkspaceId]);
}
